export default __webpack_public_path__ + "static/media/How_to_2.df9cff5e.png";